"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMaskedMarketingNumbersDto = instanceOfMaskedMarketingNumbersDto;
exports.MaskedMarketingNumbersDtoFromJSON = MaskedMarketingNumbersDtoFromJSON;
exports.MaskedMarketingNumbersDtoFromJSONTyped = MaskedMarketingNumbersDtoFromJSONTyped;
exports.MaskedMarketingNumbersDtoToJSON = MaskedMarketingNumbersDtoToJSON;
exports.MaskedMarketingNumbersDtoToJSONTyped = MaskedMarketingNumbersDtoToJSONTyped;
/**
 * Check if a given object implements the MaskedMarketingNumbersDto interface.
 */
function instanceOfMaskedMarketingNumbersDto(value) {
    if (!('vendorMaskedMarketingNumber' in value) || value['vendorMaskedMarketingNumber'] === undefined)
        return false;
    if (!('agentMaskedMarketingNumber' in value) || value['agentMaskedMarketingNumber'] === undefined)
        return false;
    return true;
}
function MaskedMarketingNumbersDtoFromJSON(json) {
    return MaskedMarketingNumbersDtoFromJSONTyped(json, false);
}
function MaskedMarketingNumbersDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'vendorMaskedMarketingNumber': json['vendorMaskedMarketingNumber'],
        'agentMaskedMarketingNumber': json['agentMaskedMarketingNumber'],
    };
}
function MaskedMarketingNumbersDtoToJSON(json) {
    return MaskedMarketingNumbersDtoToJSONTyped(json, false);
}
function MaskedMarketingNumbersDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'vendorMaskedMarketingNumber': value['vendorMaskedMarketingNumber'],
        'agentMaskedMarketingNumber': value['agentMaskedMarketingNumber'],
    };
}
